<template>
    <div class="card">
        <div class="card-header bg-info">
            <h3 class="my-0">Servicio PSE
                <el-tooltip
                    class="item"
                    content="Solicitar datos al PSE - Disponible en facturas, boletas, resúmenes, anulaciones, guías"
                    effect="dark"
                    placement="top-start">
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </h3>
        </div>
        <div class="card-body">
            <form autocomplete="off" @submit.prevent="submit">
                <div class="row pt-1">
                    <div class="col-md-12">
                        <div :class="{'has-danger': errors.send_document_to_pse}"
                            class="form-group">
                            <label class="control-label">Habilitar </label>
                            <el-switch v-model="form.send_document_to_pse"
                                active-text="Si"
                                inactive-text="No"></el-switch>
                            <small v-if="errors.send_document_to_pse"
                                class="form-control-feedback"
                                v-text="errors.send_document_to_pse[0]"></small>
                        </div>
                    </div>

                    <template v-if="form.send_document_to_pse">
                        <!-- <div class="col-md-3 mt-3">
                            <div class="form-group" :class="{'has-danger': errors.client_id_pse}">
                                <label class="control-label">ID Cliente <span class="text-danger">*</span>
                                </label>
                                <el-input v-model="form.client_id_pse"></el-input>
                                <small class="form-control-feedback" v-if="errors.client_id_pse" v-text="errors.client_id_pse[0]"></small>
                            </div>
                        </div> -->
                        <!-- <div class="col-md-12 mt-3">
                            <div class="form-group" :class="{'has-danger': errors.url_login_pse}">
                                <label class="control-label">Url autenticación <span class="text-danger">*</span></label>
                                <el-input v-model="form.url_login_pse"></el-input>
                                <small class="form-control-feedback" v-if="errors.url_login_pse" v-text="errors.url_login_pse[0]"></small>
                            </div>
                        </div> -->


                        <div class="col-12 mt-3">
                            <div class="form-group" :class="{'has-danger': errors.pse_provider_id}">
                                <label class="control-label">Partner PSE <span class="text-danger">*</span></label>
                                <el-select v-model="form.pse_provider_id"
                                    @change="changePseProvider"
                                >
                                    <el-option v-for="option in pse_providers"
                                        :key="option.id"
                                        :value="option.id"
                                        :label="option.description"
                                    ></el-option>
                                </el-select>
                            </div>
                        </div>


                        <div class="col-md-6 mt-3">
                            <div class="form-group" :class="{'has-danger': errors.user_pse}">
                                <label class="control-label">Usuario autenticación <span class="text-danger">*</span></label>
                                <el-input v-model="form.user_pse"></el-input>
                                <small class="form-control-feedback" v-if="errors.user_pse" v-text="errors.user_pse[0]"></small>
                            </div>
                        </div>
                        <div class="col-md-6 mt-3">
                            <div class="form-group" :class="{'has-danger': errors.password_pse}">
                                <label class="control-label">Contraseña autenticación <span class="text-danger">*</span></label>
                                <el-input v-model="form.password_pse" show-password></el-input>
                                <small class="form-control-feedback" v-if="errors.password_pse" v-text="errors.password_pse[0]"></small>
                            </div>
                        </div>

                        <template v-if="form.pse_provider_id === 1">
                            <div class="col-md-6 mt-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Usuario Web
                                    </label>
                                    <el-input v-model="form.web_username"
                                        disabled
                                    ></el-input>
                                </div>
                            </div>
                            <div class="col-md-6 mt-3">
                                <div class="form-group">
                                    <label class="control-label">
                                        Contraseña Web
                                    </label>
                                    <el-input v-model="form.web_password"
                                        disabled
                                    ></el-input>
                                </div>
                            </div>
                        </template>


                        <!-- <div class="col-md-12 mt-3">
                            <div class="form-group" :class="{'has-danger': errors.url_signature_pse}">
                                <label class="control-label">Url firma digital del documento <span class="text-danger">*</span></label>
                                <el-input v-model="form.url_signature_pse"></el-input>
                                <div class="sub-title text-muted"><small>Ejemplo: https://pse.com/firma-digital</small></div>
                                <small class="form-control-feedback" v-if="errors.url_signature_pse" v-text="errors.url_signature_pse[0]"></small>
                            </div>
                        </div>
                        <div class="col-md-12 mt-2">
                            <div class="form-group" :class="{'has-danger': errors.url_send_cdr_pse}">
                                <label class="control-label">Url envio CDR <span class="text-danger">*</span></label>
                                <el-input v-model="form.url_send_cdr_pse"></el-input>
                                <div class="sub-title text-muted"><small>Ejemplo: https://pse.com/envio-cdr</small></div>
                                <small class="form-control-feedback" v-if="errors.url_send_cdr_pse" v-text="errors.url_send_cdr_pse[0]"></small>
                            </div>
                        </div> -->

                        <div class="col-md-12 mt-3" v-if="pse_as_ose">
                            <div class="form-group">
                                <el-tooltip effect="dark"
                                    content="Si se activa esta opción, no usa la configuración de Entorno de Sistema (SOAP Envio)."
                                    placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                                <label class="control-label">Envíar a OSE de GIOR </label>
                                <el-switch v-model="form.pse_shipping_manager"
                                    active-text="Si"
                                    inactive-text="No"></el-switch>
                                <small v-if="errors.pse_shipping_manager"
                                    class="form-control-feedback"
                                    v-text="errors.pse_shipping_manager[0]"></small>
                            </div>
                        </div>

                    </template>
                </div>
                <div class="form-actions text-right pt-2">
                    <el-button type="primary" native-type="submit" :loading="loading_submit">Guardar</el-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            resource: 'companies',
            recordId: null,
            form: {},
            errors: {},
            loading_submit: false,
            pse_providers: [],
            pse_as_ose: true,
        }
    },
    created() {
        this.initForm()
        this.getData()
    },
    methods: {

        updateCredentials(form) { // only frontend
            const index = this.pse_providers.findIndex(item => parseInt(item.id) === parseInt(form.pse_provider_id) )

            this.pse_providers[index].username = form.user_pse
            this.pse_providers[index].password = form.password_pse                    
        },

        submit(){

            this.loading_submit = true
            this.$http.post(`/${this.resource}/store-send-pse`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)

                        this.updateCredentials(this.form)
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        console.log(error)
                    }
                })
                .then(() => {
                    this.loading_submit = false
                    this.$eventHub.$emit('reloadDataCompany')
                })

        },
        initForm(){

            this.form = {
                send_document_to_pse : false,
                url_signature_pse : null,
                url_send_cdr_pse : null,
                client_id_pse: null,
                url_login_pse: null,
                password_pse: null,
                user_pse: null,
                pse_shipping_manager: false,

                pse_provider_id: null,
                web_username: null,
                web_password: null
            }

            this.errors = {}

        },
        getData() {
            this.$http.get(`/${this.resource}/record-send-pse`)
                .then(response => {
                    const { pse_providers, ...dataForm } = response.data
                    this.form = dataForm
                    this.pse_providers = pse_providers

                    parseInt(this.form.pse_provider_id) === 1 ? this.pse_as_ose = true : this.pse_as_ose = false
                })
        },

        changePseProvider() {
            // 1 es GIOR
            parseInt(this.form.pse_provider_id) === 1 ? this.pse_as_ose = true : this.pse_as_ose = false, this.form.pse_shipping_manager = false

            let pse_provider_selected = this.pse_providers.filter(item => parseInt(item.id) === parseInt(this.form.pse_provider_id))

            this.form.user_pse = pse_provider_selected[0].username
            this.form.password_pse = pse_provider_selected[0].password
            this.form.web_username = pse_provider_selected[0].web_username
            this.form.web_password = pse_provider_selected[0].web_password
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/companies/signature_pse/index.vue